import React from "react";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from "components/shadcn/ui/dialog";
import { Button } from "components/shadcn/ui/button";

interface ConfirmDialogProps {
  title: React.ReactNode;
  description: React.ReactNode;
  trigger?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  confirmVariant?: "default" | "destructive" | "primary";
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  showCancelButton?: boolean;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  title,
  description,
  trigger,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  confirmVariant = "primary",
  open,
  onOpenChange,
  showCancelButton,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onOpenChange?.(false);
  };

  const handleCancel = () => {
    onOpenChange?.(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className="text-sm font-normal text-gray-800">
            {description}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="mt-4">
          {showCancelButton && (
            <Button variant="outline" onClick={handleCancel}>
              {cancelLabel}
            </Button>
          )}
          <Button variant={confirmVariant} onClick={handleConfirm}>
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDialog;
